<p>citation-guide works!</p>
